import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../auth/auth.service";
import { ProjectService } from "../project/project.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class NotProductionService implements CanActivate {
  env: any = environment;

  constructor(
    private authService: AuthService,
    private router: Router,
    private projectService: ProjectService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return !this.env.production;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/not-production/not-production.service.ts